export default __webpack_public_path__ + "static/students-002064e58f563e88693ddabaae3ea9f6.png";